import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import {
  dataabout,
  meta,
  worktimeline,
  skills,
  tools,
} from "../../content_option";
import profileImage from "../../assets/images/proHeadcropped.webp";

export const About = () => {
  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title> About | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <p className="section_label"><span className="idx">~/</span>about</p>
            <h1 className="display-4 mb-4">About me</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <p className="section_label"><span className="idx">01</span>{"// whoami"}</p>
            <img
              src={profileImage}
              alt="Drew Jordan"
              className="about__photo"
            />
            <h3 className="color_sec py-2">{dataabout.title}</h3>
          </Col>
          <Col lg="7" className="d-flex align-items-center">
            <div>
              <p>{dataabout.aboutme}</p>
            </div>
          </Col>
        </Row>
        <Row className=" sec_sp">
          <Col lg="5">
            <p className="section_label"><span className="idx">02</span>{"// experience"}</p>
            <h3 className="color_sec py-2">Work Timeline</h3>
          </Col>
          <Col lg="7">
            <table className="table caption-top">
              <tbody>
                {worktimeline.map((data, i) => {
                  return (
                    <tr key={i}>
                      <th scope="row">{data.jobtitle}</th>
                      <td>{data.what && <span className="job__type">{data.what}</span>}</td>
                      <td className="job__where">{data.where}</td>
                      <td className="job__date">{data.date}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <p className="section_label"><span className="idx">03</span>{"// stack"}</p>
            <h3 className="color_sec py-2">Skills</h3>
          </Col>
          <Col lg="7">
            {skills.map((group, i) => {
              return (
                <div className="skill_group" key={i}>
                  <h5 className="skill_group__title">{group.title}</h5>
                  <div className="skill_tags">
                    {group.items.map((item, j) => (
                      <span className="skill_tag" key={j}>
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <p className="section_label"><span className="idx">04</span>{"// tools"}</p>
            <h3 className="color_sec py-2">Tools</h3>
          </Col>
          <Col lg="7">
            {tools.map((data, i) => {
              return (
                <div className="service_ py-4" key={i}>
                  <h5 className="service__title">{data.name}</h5>
                  <p className="service_desc">{data.description}</p>
                </div>
              );
            })}
          </Col>
        </Row>
      </Container>
    </HelmetProvider>
  );
};
